import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container': {
      background: palette.background.tableHead,
    },
  },
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
    },
    '& .logo-image': {
      width: 130,
    },
  },

  '.seva-weightloss-container': {
    /* Header - styles */
    '& .header-wrapper': {
      background: palette.secondary.contrastText,

      '& .top-bar-logo-container .image': {
        height: '100%',
      },

      '& .menu-item, & .mobile-menu-icon, & .header-phone-link': {
        color: palette.text.highlight,
      },
      '&.active-header': {
        background: palette.text.highlight,
        boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',

        '& .menu-item, & .mobile-menu-icon, & .header-phone-link': {
          color: palette.text.primary,
        },
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.secondary.contrastText,
      marginBottom: 100,
      
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '& .section-alternate__content': {
          '@media(min-width: 900px)': {
            padding: '0 48px',
          },
        },
        '& .hero-subtitle': {
          maxWidth: 475,
          fontSize: 20,
        },
      },
      '& .hero-left-section': {
        '& .hero-title, .hero-subtitle': {
          color: palette.text.highlight,
        }
      },
      '& .image-wrapper': {
        position: 'relative',

        '@media(min-width: 900px)': {
          bottom: -85,
        },

        '& .image': {
          boxShadow: 'none',

          '@media(min-width: 900px)': {
            height: 726,
            width: 'auto',
          }
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .section-header__title': {
        paddingBottom: 40,
      },
      '@media(min-width: 900px)': {
        borderBottom: `1px solid ${palette.text.border}`,
      },
      '& .benefits-wrapper': {
        padding: '0 24px',
      },
      '& .service-tile-wrapper': {
        '& .image': {
          width: 76,
        }
      }
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.background.footer
      },
      '& #pricing-benefit-section': {
        color: palette.text.highlight,

        '@media(min-width: 900px)': {
          marginTop: 10,
          borderTop: `1px solid ${palette.text.border}`,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
            borderTop: `1px solid ${palette.text.border}`,
          },

          '& .section-header': {
            maxWidth: 720,

            '& .section-header__title, .section-header__subtitle': {
              color: palette.text.highlight,
            },

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '& .planCard': {
          backgroundColor: palette.background.paper,
          
          '&:hover': {
            backgroundColor: palette.secondary.main,
            '& .MuiTypography-root': {
              color: palette.text.primary,
            },
            '& .MuiButtonBase-root': {
              border: `1px solid ${palette.text.border}`,
            }
          }
        },
      },
    },

    /* Pricing & Benefits / Addons - Styles */
    '& .addons-wrapper': {
      backgroundColor: palette.background.footer,

      '& .hero-image': {
        borderRadius: 32,
      },

      '& .section-header__title, .section-header__subtitle': {
        color: palette.text.highlight,
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      '& .section': {
        borderBottom: `1px solid ${palette.text.border}`,
      },
      '& .howitworks-wrapper': {
        '& .how-cover-image': {
          height: 'auto',
        }
      },
      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
        marginBottom: 0,
        borderBottom: `1px solid ${palette.text.disabled}`,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.secondary.main,

      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonialSection': {
        padding: '40px 32px',
  
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },

        '& .react-multiple-carousel__arrow--left': {
          left: '25%',

          '@media(max-width: 899px)': {
            left: 0,
          },
        },
        '& .react-multiple-carousel__arrow--right': {
          right: '25%',

          '@media(max-width: 899px)': {
            right: 0,
          },
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-header': {
        color: `${palette.text.primary} !important`
      },
      '& .savings-topheader': {
        color: `${palette.text.highlight} !important`,
      }
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.primary.contrastText,
        }
      },
    },
 
    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Footer */
    '& .footer-wrapper': {
      '& .logo-image': {
        width: 130,
      }
    },

    /* Packages - Checkout */
    '& #order-package-item': {
      '& .MuiTableCell-head': {
        color: palette.text.highlight,
      }
    },
  },
};